// 涨停分析
import request from '@/utils/request'
import { apiUrl } from './config'
type dataType = any
export default {
    getUpAnalysis(data: dataType): Promise<{
        response?: Response
    }> {
        return request({
            url: apiUrl + '/rjhy-finance/api/1/stock/upbao/detail',
            method: 'get',
            params: data,
            headers: {
                appCode: 'com.rjhy.uranus',
                token: data.token
            },
            sign: true
        })
    }
}
